"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRadioInputs = exports.getCheckboxInputs = exports.answerAsText = exports.answerAsInputs = exports.ShortAnswer = exports.NoAnswer = exports.InputAnswer = exports.EmptyAnswer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiLibrary = require("@sm360/ui-library");

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _reactI18nify = require("react-i18nify");

var _InputCurrency = _interopRequireDefault(require("@sm360/ui-library/dist/components/Input/InputCurrency"));

var _InputTypes = _interopRequireDefault(require("../../constants/InputTypes.js"));

var _QuestionsListHelpers = require("../../helpers/QuestionsListHelpers");

var LocaleService = {
  t: _reactI18nify.translate
};
var t = LocaleService.t;

var getRadioInputs = function getRadioInputs(id, choices, answer, onAnswerChange, readOnly) {
  return choices.map(function (choice, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "cell shrink".concat(choices.length === 1 ? ' question-section--singleAnswer' : ''),
      key: "radio-".concat(id, "-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(_uiLibrary.Radio, {
      id: "radio-".concat(id, "-").concat(index),
      name: id,
      label: t("".concat(choice.labelKey)),
      value: choice.value,
      checked: answer === choice.value,
      onChange: function onChange() {
        return onAnswerChange(id, choice.value);
      },
      disabled: readOnly,
      color: "secondary",
      outline: true
    }));
  });
};

exports.getRadioInputs = getRadioInputs;

var getCheckboxInputs = function getCheckboxInputs(id, choices) {
  var answer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var onAnswerChange = arguments.length > 3 ? arguments[3] : undefined;
  var readOnly = arguments.length > 4 ? arguments[4] : undefined;

  var handleChange = function handleChange(choice, checked) {
    var newAnswer = (0, _uniq.default)(answer) || [];

    if (checked) {
      if (choice.disableOthers) {
        newAnswer = [choice.value];
      } else {
        var firstAnswer = newAnswer.length > 0 ? choices.find(function (element) {
          return element.value === newAnswer[0];
        }) : null; // if the first answer has disableOthers, remove it

        if (firstAnswer && firstAnswer.disableOthers) {
          newAnswer = [];
        }

        if (newAnswer.indexOf(choice.value) === -1) {
          newAnswer.push(choice.value);
        }
      }
    } else {
      newAnswer = newAnswer.filter(function (item) {
        return item !== choice.value;
      });
    }

    onAnswerChange(id, newAnswer);
  };

  return choices.map(function (choice, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "cell shrink",
      key: "checkbox-".concat(id, "-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(_uiLibrary.Checkbox, {
      id: "checkbox-".concat(id, "-").concat(index),
      label: t("".concat(choice.labelKey)),
      checked: answer && answer.indexOf(choice.value) >= 0,
      onChange: function onChange(checked) {
        return handleChange(choice, checked);
      },
      disabled: readOnly,
      color: "secondary",
      outline: true
    }));
  });
};

exports.getCheckboxInputs = getCheckboxInputs;

var ShortAnswer = function ShortAnswer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "answer"
  }, children);
};

exports.ShortAnswer = ShortAnswer;

var InputAnswer = function InputAnswer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-y"
  }, children);
};

exports.InputAnswer = InputAnswer;

var NoAnswer = function NoAnswer() {
  return /*#__PURE__*/_react.default.createElement(ShortAnswer, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "no-answer"
  }, LocaleService.t('OFFICIAL_EVALUATION.UNANSWERED')));
};

exports.NoAnswer = NoAnswer;

var EmptyAnswer = function EmptyAnswer() {
  return /*#__PURE__*/_react.default.createElement(ShortAnswer, null, "-");
};

exports.EmptyAnswer = EmptyAnswer;

var answerAsText = function answerAsText(type, choices, answer) {
  var text = answer;

  if (!(0, _QuestionsListHelpers.isAnswered)(answer)) {
    return /*#__PURE__*/_react.default.createElement(NoAnswer, null);
  }

  if (type === _InputTypes.default.RADIO) {
    var choice = choices.find(function (c) {
      return c.value === answer;
    });
    text = choice ? t("".concat(choice.labelKey)) : text;
  }

  if (type === _InputTypes.default.CHECKBOX) {
    var selectedCount = answer.length || 0;
    text = t('OFFICIAL_EVALUATION.UNANSWERED');

    if (selectedCount > 0) {
      var selectedAnswers = answer.map(function (selectedAnswer) {
        var selectedChoice = choices.find(function (choice) {
          return selectedAnswer === choice.value;
        });
        return t(selectedChoice.labelKey);
      });
      text = "".concat((0, _uniq.default)(selectedAnswers).join(', '));
    }
  }

  if (type === _InputTypes.default.TEXTAREA) {
    return /*#__PURE__*/_react.default.createElement(_uiLibrary.TextArea, {
      resizable: false,
      readOnly: true,
      disabled: true,
      value: answer,
      className: "trade-in__textarea--read-only"
    });
  }

  return /*#__PURE__*/_react.default.createElement(ShortAnswer, null, /*#__PURE__*/_react.default.createElement("div", null, text));
};

exports.answerAsText = answerAsText;

var answerAsInputs = function answerAsInputs(id, type, choices, answer, onAnswerChange, locale, readOnly, placeholder) {
  var inputs = '';

  switch (type) {
    case _InputTypes.default.RADIO:
      inputs = getRadioInputs(id, choices, answer, onAnswerChange, readOnly);
      break;

    case _InputTypes.default.CHECKBOX:
      inputs = getCheckboxInputs(id, choices, answer, onAnswerChange, readOnly);
      break;

    case _InputTypes.default.TEXTAREA:
      inputs = /*#__PURE__*/_react.default.createElement(_uiLibrary.TextArea, {
        value: answer,
        onChange: function onChange(value) {
          return onAnswerChange(id, value);
        },
        disabled: readOnly,
        placeholder: placeholder
      });
      break;

    case _InputTypes.default.TEXT:
      inputs = /*#__PURE__*/_react.default.createElement(_uiLibrary.Input, {
        value: answer,
        onChange: function onChange(value) {
          return onAnswerChange(id, value);
        },
        disabled: readOnly,
        placeholder: placeholder
      });
      break;

    case _InputTypes.default.CURRENCY:
      inputs = /*#__PURE__*/_react.default.createElement(_InputCurrency.default, {
        value: answer,
        onChange: function onChange(value) {
          return onAnswerChange(id, value);
        },
        locale: locale,
        disabled: readOnly,
        placeholder: placeholder
      });
      break;

    default:
      inputs = '';
  }

  return /*#__PURE__*/_react.default.createElement(InputAnswer, null, inputs);
};

exports.answerAsInputs = answerAsInputs;
ShortAnswer.propTypes = {
  className: _propTypes.default.string
};